import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { GetApi } from "../../../js_assets/Network";
import { api_url } from "../../../js_assets/ConfigApp";
import axios from "axios";
import SearchIcon from "@material-ui/icons/Search";
import Navigation from "@material-ui/icons/Navigation";
import CloseIcon from "@material-ui/icons/Close";
import PartyMode from "@material-ui/icons/PartyMode";
import MyLocation from "@material-ui/icons/MyLocation";
import CircularProgress from "@material-ui/core/CircularProgress";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AppAdminContainer from "../AppAdminContainer";
import Divider from "@material-ui/core/Divider";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import "../../../shared_css/main_app_css.css";

import Hammer from "react-hammerjs";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 8,
    margin: 12,
  },
  divider: {
    width: "100%",
  },
  ButtonSearch: {
    backgroundColor: "#007bff",
    color: "white",
    "&:hover": {
      background: "#007bff",
    },
    padding: "5px",
  },
  ButtonLocation: {
    backgroundColor: "#4CAF50",
    color: "white",
    "&:hover": {
      background: "#4CAF50",
    },
    padding: "5px",
  },
  ButtonGuide: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    margin: theme.spacing.unit,
    padding: "2px",
  },
  tab: {
    flexGrow: 1,
    marginTop: -5,
    backgroundColor: "#f7faea",
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
  tab_button: {
    fontSize: 18,
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
  iocns: {
    fontSize: 18,
  },
});

class AdminProteinGuide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list_Citys: [],
      guide_data: [],
      selected_tab: 0,
      loading_state_iocn: false,
      Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
    };
  }

  componentDidMount() {
    axios
      .get(`${api_url}/api/Admin/GetCitys`)
      .then((result) => this.setState({ list_Citys: result.data }))
      .catch(function (error) {
        //console.log(error);
      });
  }

  get_guide_data_set = (selected_city_id) => {
    const { selected_tab } = this.state;
    this.setState({ guide_data: [], loading_state_iocn: true });

    switch (selected_tab) {
      case 0:
        axios
          .get(`${api_url}/api/Guide/GetRestaurantsByCity/${selected_city_id}`)
          .then((result) => {
            this.setState({ loading_state_iocn: false });

            this.setState({ guide_data: result.data });
            //console.log(result.data)
          })
          .catch(function (error) {
            //console.log(error);
          });
        break;
      case 1:
        axios
          .get(`${api_url}/api/Guide/GetStoresByCity/${selected_city_id}`)
          .then((result) => {
            this.setState({ loading_state_iocn: false });

            this.setState({ guide_data: result.data });
          })
          .catch(function (error) {
            //console.log(error);
          });
        break;
      default:
        break;
    }
  };
  get_guide_data_set_location = () => {
    let User_Info = JSON.parse(localStorage.getItem("User_Info"));

    const { selected_tab } = this.state;
    this.setState({ guide_data: [], loading_state_iocn: true });

    switch (selected_tab) {
      case 0:
        axios
          .get(`${api_url}/api/Guide/GetRestaurantsByCity/${User_Info.City_id}`)
          .then((result) => {
            this.setState({ loading_state_iocn: false });

            this.setState({ guide_data: result.data });
          })
          .catch(function (error) {
            //console.log(error);
          });
        break;
      case 1:
        axios
          .get(`${api_url}/api/Guide/GetStoresByCity/${User_Info.City_id}`)
          .then((result) => {
            this.setState({ loading_state_iocn: false });

            this.setState({ guide_data: result.data });
          })
          .catch(function (error) {
            //console.log(error);
          });
        break;
      default:
        break;
    }
  };

  shuffle = (array) => {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  };

  sort_guide_data = (guide_data) => {
    let sort_data = this.shuffle(guide_data);
    this.setState({ guide_data: sort_data });
  };

  tabChange = (event, selected_tab) => {
    this.setState({ selected_tab });
  };

  redirectToUrl = (Component) => {
    window.location.href =
      window.location.protocol +
      "//" +
      window.location.hostname +
      ":" +
      window.location.port +
      Component;
  };

  Delete_Guide = (ID) => {
    const { Admin_Info } = this.state;

    GetApi(
      `/api/Admin/DeleteGuide/${ID}/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    ).then(() => {
      alert("تم الحدف");
    });
  };

  render() {
    const { classes } = this.props;
    const {
      list_Citys,
      selected_tab,
      guide_data,
      loading_state_iocn,
    } = this.state;
    let optionItems = list_Citys.map((citys) => (
      <option value={citys.city_Id} key={citys.city_Id}>
        {citys.city_Name}
      </option>
    ));

    return (
      <AppAdminContainer Title={"دليل المطاعم والمتاجر"}>
        <div className="container">
          <Tabs
            variant="fullWidth"
            value={selected_tab}
            onChange={this.tabChange}
            className={classes.tab}
          >
            <Tab className={classes.tab_button} label="المطاعم" />

            <Tab className={classes.tab_button} label="المتاجر" />
          </Tabs>

          <div>
            <Grid container spacing={24} className={classes.root}>
              <Grid item xs>
                <select
                  ref="list_city"

                  name="list_city"
                  ref="list_city"
                >
                  {optionItems}
                </select>
              </Grid>

              <Grid item xs>
                <Hammer
                  onTap={() =>
                    this.get_guide_data_set(this.refs.list_city.value)
                  }
                >
                  <div>
                    <button
                      size="small"
                      variant="contained"
                      className={classes.ButtonSearch}
                    >
                      <SearchIcon />
                    </button>
                  </div>
                </Hammer>
              </Grid>
              <Grid item xs>
                <Hammer onTap={() => this.get_guide_data_set_location()}>
                  <div>
                    <button
                      size="small"
                      variant="contained"
                      className={classes.ButtonLocation}
                    >
                      <LocationOnIcon />
                    </button>
                  </div>
                </Hammer>
              </Grid>
            </Grid>
            <Grid container justify="center">
              <Hammer
                onTap={() =>
                  this.redirectToUrl("/Admin/FormProteinGuide?StoreId=New")
                }
              >
                <div>
                  <button
                    size="small"
                    variant="contained"
                    className={classes.ButtonLocation}
                  >
                    <label> اضافة للدليل</label>
                  </button>
                </div>
              </Hammer>
            </Grid>

            <Divider className={classes.divider} />

            {loading_state_iocn ? (
              <div className="centerloadingicon">
                <CircularProgress />
              </div>
            ) : guide_data.length == 0 ? null : (
              guide_data.map((guid) => {
                return (
                  <div>
                    <div className="w3-cell-row">
                      <div className="w3-cell">
                        <img
                          className="w3-circle"
                          src={`${api_url}/Content/Guide_Images/${guid.store_Image}`}
                        ></img>
                      </div>
                      <div className="w3-cell w3-container">
                        <h4>{guid.store_Name}</h4>
                        <i>
                          <LocationOnIcon className={classes.iocns} />{" "}
                        </i>{" "}
                        <span className="span12px"> {guid.city_Name} </span>
                        <i>
                          <MyLocation className={classes.iocns} />{" "}
                        </i>{" "}
                        <span className="span12px">
                          {guid.description_Of_Place}{" "}
                        </span>{" "}
                        <br></br>
                        <p> {guid.store_Description} </p>
                        <button
                          size="small"
                          variant="contained"
                          className={classes.ButtonGuide}
                          href={guid.store_Link_Location}
                        >
                          <Navigation />{" "}
                          <span className="span12px"> عنوان الموقع</span>
                        </button>
                        <button
                          size="small"
                          variant="contained"
                          className={classes.ButtonGuide}
                          href={guid.social_Media_Link}
                        >
                          <PartyMode />{" "}
                          <span className="span12px"> حساب المتجر</span>
                        </button>
                        <button
                          size="small"
                          variant="contained"
                          className={classes.ButtonGuide}
                          onClick={() =>
                            this.redirectToUrl(
                              `/Admin/FormProteinGuide?StoreId=${guid.store_Id}`
                            )
                          }
                        >
                          <span className="span12px"> تحديث</span>
                        </button>
                        <button
                          size="small"
                          variant="contained"
                          className={classes.ButtonGuide}
                          onClick={() => {
                            if (window.confirm("هل متاكد انك تبغى تحدف  ؟؟"))
                              this.Delete_Guide(guid.store_Id);
                          }}
                        >
                          <CloseIcon />{" "}
                          <span className="span12px"> حذف المكان</span>
                        </button>
                      </div>
                    </div>

                    <hr></hr>
                  </div>
                );
              })
            )}
            {/* {loading_state_iocn ? <div className="centerloadingicon" ><CircularProgress /></div> : null} */}
          </div>
        </div>
      </AppAdminContainer>
    );
  }
}
AdminProteinGuide.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminProteinGuide);
